import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
} from '@mui/material';
import ReactDOM from 'react-dom';

const CustomConfirm = ({
  message,
  resolve,
  reject,
  isDark,
  warning,
  confirmationText,
  cancellationText,
  display,
}) => {
  const [open, setOpen] = useState(true);

  const handleConfirm = () => {
    setOpen(false);
    resolve();
  };

  const handleCancel = () => {
    setOpen(false);
    reject();
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      style={{
        zIndex: 2000,
      }}
      //   {...dialogProps}
      PaperProps={{
        sx: {
          width: '355px',
          padding: '20px',
          position: 'fixed',
          borderRadius: '10px',
          bottom: '25px',
          right: '60px',
          backgroundColor: isDark ? '#454545' : '#fff',
          color: isDark ? '#fff' : '#333',
        },
      }}
    >
      <DialogTitle
        style={{
          textAlign: 'center',
          wordBreak: 'break-word',
          fontSize: '16px',
        }}
      >
        {message || 'Are you sure?'}
      </DialogTitle>
      {/* <DialogContent>
        <DialogContentText style={{ textAlign: 'center', wordBreak: 'break-word', fontWeight: 'bold', fontSize: '1.2em' }}>{message || 'Are you sure?'}</DialogContentText>
      </DialogContent> */}
      <DialogActions style={{ flexDirection: 'column' }}>
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            width: '100%',
            padding: '0px 40px',
          }}
        >
          <Box
            onClick={handleConfirm}
            sx={{
              width: '100%',
              backgroundColor: `${warning ? '#ff0000' : '#52ADC8'}`,
              borderRadius: '30px',
              color: '#fff',
              boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
              textAlign: 'center',
              padding: '10px',
              cursor: 'pointer',
              fontWeight: 'bold',
            }}
          >
            {confirmationText || 'OK'}
          </Box>
          <Box
            onClick={handleCancel}
            sx={{
              width: '100%',
              backgroundColor: '#fff',
              borderRadius: '30px',
              color: '#52ADC8',
              boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.35)',
              textAlign: 'center',
              padding: '10px',
              cursor: 'pointer',
              fontWeight: 'bold',
              display: display,
            }}
          >
            {cancellationText || 'Cancel'}
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

const CustomConfirmDialog = options => {
  const {
    message,
    confirmationText,
    cancellationText,
    isDark,
    warning = false,
    display = '',
  } = options;
  return new Promise((resolve, reject) => {
    const container = document.createElement('div');
    document.body.appendChild(container);

    const cleanup = () => {
      ReactDOM.unmountComponentAtNode(container);
      document.body.removeChild(container);
    };

    const resolvePromise = () => {
      cleanup();
      resolve();
    };

    const rejectPromise = () => {
      cleanup();
      reject();
    };

    ReactDOM.render(
      <CustomConfirm
        message={message}
        resolve={resolvePromise}
        reject={rejectPromise}
        isDark={isDark}
        warning={warning}
        confirmationText={confirmationText}
        cancellationText={cancellationText}
        display={display}
      />,
      container
    );
  });
};

export default CustomConfirmDialog;
